import { registerExternalGetter } from '@meego/remote-loader';

const externalGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {};

// 依赖声明
export const openappCommonDeps = [
  '@meego-progressive/onboarding/help/components',
  '@meego-progressive/onboarding/help',
];

// 声明 @meego-remote/onboarding/deps 这个 preset 方便使用，上面 externalGetterMap 中也可以手动定义依赖模块
externalGetterMap['@meego-remote/openapp/common-deps'] = [
  () => Promise.resolve(),
  openappCommonDeps,
];

const init = () => {
  Object.entries(externalGetterMap).forEach(([name, [getter, dependencies]]) =>
    registerExternalGetter(name, getter, dependencies),
  );
};

export { init };
